import { create } from 'zustand';

interface BreadcrumbState {
  dynamicLabels: Record<string, string>;
  setLabel: (path: string, label: string) => void;
  clearLabels: () => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  dynamicLabels: {},
  setLabel: (path, label) =>
    set((state) => ({
      dynamicLabels: { ...state.dynamicLabels, [path]: label },
    })),
  clearLabels: () => set({ dynamicLabels: {} }),
}));
